
import React, { useContext, useEffect, useRef, useState } from "react";
import "./SuccessComponent.css";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { set_image_upload_status } from "../store/image_upload";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import FileContext from "../context/Context";
// import { ignore } from "antd/es/theme/useToken";
import CloseIcon from '@mui/icons-material/Close';

const SuccessfulComponent = () => {
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [audit_status, set_audit_status] = useState(null);
    const [ratingSucceeded, setRatingSucceded] = useState(false);
    const dispatch = useDispatch();
    const [rating, setRating] = useState(0);
    const navigate = useNavigate();
    const { audit_id } = useParams();
    console.log(audit_id, "26")

    const [qualityCheck, setQualityCheck] = useState(true);
    const [reportGeneration, setReportGeneration] = useState(false);
    const [reportSubmission, setReportSubmission] = useState(false);

    useEffect(() => {
        const func = async () => {
            // const res = await axios.post("/create_audit/audit_status", { audit_id: audit_id });
            const res = await axios.post("/create_audit/get_retake_status", { audit: audit_id });
            // console.log(res.data);
            
            console.log(res.data.retake_status);
            set_audit_status(res.data.retake_status);
            if (res.data.retake_status === "processed") {
                setReportGeneration(true)
            }
        }
        func();
    }, [])



    const closeTab = () => {
        navigate('/login')

    };


    const handleButtonClick = () => {
        setPopupOpen(true);
    };

    const handleClosePopup = () => {
        setPopupOpen(false);
    };

    const handleStarClick = (star) => {
        setRating(star)

    };
    const handleSubmit = () => {
        setRatingSucceded(true)

    }


    const check = `${process.env.PUBLIC_URL}/custom-icons/timer.png`;
    const timer = `${process.env.PUBLIC_URL}/inspection-images/check-icon.png`;
    const star = `${process.env.PUBLIC_URL}/inspection-images/star.png`;
    const step1_pink = `${process.env.PUBLIC_URL}/custom-icons/step1-pink.svg`;;
    const step2_grey = `${process.env.PUBLIC_URL}/custom-icons/step2-grey.svg`;
    const step3_grey = `${process.env.PUBLIC_URL}/custom-icons/step3-grey.png`;
    const step2_pink = `${process.env.PUBLIC_URL}/custom-icons/step2-pink.png`;
    const step3_pink = `${process.env.PUBLIC_URL}/custom-icons/step3-pink.png`;
    const close = `${process.env.PUBLIC_URL}/custom-icons/close.png`;
    // const success = `${process.env.PUBLIC_URL}/inspection-images/success-background.png`;
    const starEmpty = `${process.env.PUBLIC_URL}/inspection-images/image.png`;
    const starFilled = `${process.env.PUBLIC_URL}/inspection-images/star-filled.png`;


    return (
        <>
            <div className="success-container">
                {/* <div className="illustration-section">
                    <img src={success} alt="Success Illustration" />
                </div> */}
                <div className="content-section">
                    <div className="check-icon">
                        <img src={check} alt="Check Icon" />
                    </div>
                    <h2>Success</h2>
                    <p>Inspection is completed! You can close the window now</p>
                    <ol className="steps-list">
                        <li className="step">
                            <span className="step-number-audit">
                                <img src={step1_pink} alt="Step 1" />
                            </span>
                            Quality Check
                            {!qualityCheck && (
                                <span>
                                    <CircularProgress
                                        sx={{ color: "#FC350B", width: "20px !important", height: "20px !important" }}
                                    />
                                </span>
                            )}
                            {!qualityCheck && <span className="upload-status">Uploading</span>}
                            <span className="vertical-line"></span>
                        </li>
                        <li className="step">
                            <span className="step-number-audit">
                                {qualityCheck ? (
                                    <img src={step2_pink} alt="Step 2" />
                                ) : (
                                    <img src={step2_grey} alt="Step 2" />
                                )}
                            </span>

                            Report Generation
                            {/* {qualityCheck && !reportGeneration && (
      <span>
        <CircularProgress
          sx={{ color: "#FC350B", width: "20px !important", height: "20px !important" }}
        />
      </span>
    )} */}
                            <span className="vertical-line2"></span>
                        </li>
                        <li className="step disabled-step">
                            <span className="step-number-audit">
                                {reportGeneration ? (
                                    <img src={step3_pink} alt="Step 3" />
                                ) : (
                                    <img src={step3_grey} alt="Step 3" />
                                )}
                            </span>
                            Report Submission
                            {/* {qualityCheck && reportGeneration && !reportSubmission && (
                <span>
                  <CircularProgress
                    sx={{ color: "#FC350B", width: "20px !important", height: "20px !important" }}
                  />
                </span>
              )} */}
                        </li>
                    </ol>
                    <button
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0.2rem",
                            border: "1.5px solid #FC350B",
                            padding: "0rem 1rem",
                            backgroundColor: "white",
                            borderRadius: "3px",
                            opacity: "0.9",
                            width: "100%"
                        }}
                        onClick={closeTab}
                    >
                        <span
                            style={{
                                fontSize: "0.9rem",
                                fontFamily: "'Montserrat', sans-serif",
                                color: "#FC350B",
                                padding: "0.5rem",
                                cursor: "pointer"
                            }}

                        >
                            Close
                        </span>
                    </button>
                </div>
                <button className="rate-experience-btn" onClick={handleButtonClick}>
                    <img src={star} alt="Star Icon" /> RATE EXPERIENCE
                </button>
            </div>

            {isPopupOpen && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <div className="close-popup" onClick={handleClosePopup}><CloseIcon /></div>

                        <div className="rating-heading"><h4>How was your experience?</h4></div>
                        <p>Please share with us your feedback:</p>
                        <div className="rating-stars">
                            {[1, 2, 3, 4, 5].map(starIndex => (
                                <img
                                    key={starIndex}
                                    src={starIndex <= rating ? starFilled : starEmpty}
                                    alt={`Star ${starIndex}`}
                                    className="star-icon"
                                    onClick={() => handleStarClick(starIndex)}
                                />
                            ))}
                        </div>
                        <button
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.2rem",
                                border: rating != 0 ? "1.5px solid #FC350B" : "1.5px solid #0000003D",
                                padding: "0rem 1rem",
                                backgroundColor: rating != 0 ? "#FC350B" : "#dcdcdc",
                                color: rating != 0 ? "#ffffff" : "#0000003D",
                                borderRadius: "3px",
                                opacity: "0.9",
                                width: "100%",
                                marginTop: "0.5rem"

                            }}
                            disabled={rating != 0 ? false : true}
                            onClick={handleSubmit}
                        >
                            <p
                                style={{
                                    fontSize: "0.9rem",
                                    fontFamily: "'Montserrat', sans-serif",
                                    //   color: "#FC350B",
                                    color: rating != 0 ? "#ffffff" : "#0000003D",
                                    padding: "0.5rem",
                                    cursor: "pointer"
                                }}

                            >

                                Submit
                            </p>
                        </button>

                        {/* <p>Your rating: {rating} {rating > 1 ? 'stars' : 'star'}</p> */}
                    </div>
                </div>
            )}
            {isPopupOpen && ratingSucceeded && (
                <div className="popup-overlay">
                    <div className="popup-content-after-rating">
                        <div className="close-popup" onClick={handleClosePopup}><CloseIcon /></div>

                        <div className="rating-heading-completion"><h4>Thank you for sharing
                            your feedback</h4></div>
                        <p style={{ textAlign: "center" }}>We appreciate your input and will use it to improve our services.</p>


                        {/* <p>Your rating: {rating} {rating > 1 ? 'stars' : 'star'}</p> */}
                    </div>
                </div>
            )}
        </>
    );
};
export default SuccessfulComponent;
